<template>
  <CheckInput
    v-bind="$attrs"
    :id="$attrs.id || 'YesOrNoCheckInput'"
    :class="$attrs.class || 'field required'"
    :validations="$attrs.validations || { booleanRequired: true }"
    :options="yesOrNoOptions"
    @input="$emit('input', $event)"
  />
</template>
<script>
import CheckInput from '@/components/ui/newComponents/CheckInput.vue'
export default {
  name: 'YesOrNoCheckInput',
  components: {
    CheckInput,
  },
  inheritAttrs: false,
  props: {
    inverse: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
  },
  emits: ['input'],
  data() {
    return {
      yesOrNoOptions: [
        { label: 'Sim', value: !this.inverse },
        { label: 'Não', value: this.inverse },
      ],
    }
  },
}
</script>
<style lang="scss"></style>
